import Axios from "axios";
import {
  SET_SALES_LEADS_LIST,
  UNSET_SALES_LEADS_LIST,
} from "@/store/mutation-types";
import {
  saveUpdateSalesLeads,
  getSalesLeads,
  saveUpdateActivityLogs as saveUpdateActivityLogsApi,
  getSalesLeadsbyId as getSalesLeadsbyIdApi,
} from "@/store/api";
// initial state
const state = {
  getSalesLeads: [],
  editingSalesLeads: null,
  viewingSalesLeads: null,
};

const getters = {
  getSalesLeads(state) {
    return state.getSalesLeads;
  },
  getEditingSalesLeads: (state) => state.editingSalesLeads,
  getViewingSalesLeads: (state) => state.viewingSalesLeads,
};

const mutations = {
  [SET_SALES_LEADS_LIST](state, data) {
    state.getSalesLeads = data;
  },
  [UNSET_SALES_LEADS_LIST](state) {
    state.getSalesLeads = [];
  },
  setEditingSalesLeads(state, lead) {
    state.editingSalesLeads = lead;
  },
  setViewingSalesLeads(state, lead) {
    state.viewingSalesLeads = lead;
  },
};

const actions = {
  saveUpdateSalesLeads({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSalesLeads, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  saveUpdateActivityLogs({ commit }, { lead_id, formData }) {
    const saveUpdateActivityLogs = `${saveUpdateActivityLogsApi}/${lead_id}`;
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateActivityLogs, formData)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
        .finally(() => commit("UNSET_LOADING"));
    });
  },

  getSalesLeads({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSalesLeads, data)
        .then(function (response) {
          commit("SET_SALES_LEADS_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_SALES_LEADS_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  // FIXED: The main problem was here
  getSalesLeadsById({ commit }, data) {
    const getSalesLeadsById = `${getSalesLeadsbyIdApi}/${data}`;
    // commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSalesLeadsById)
        .then((response) => {
          // FIX: You need to resolve the promise, not just return
          resolve(response.data); // This was missing!
        })
        .catch((error) => {
          console.error("API Error:", error.response?.data || error.message);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
